import { useAuthStore } from "@/stores/useAuthStore";

/**
 * Trivial selector that exposes the current user state from useAuthStore.
 * Exists so future code can migrate to a real GET /auth/whoami query without
 * touching consumers.
 */
export function useCurrentUser() {
  const status = useAuthStore((state) => state.status);
  const userId = useAuthStore((state) => state.userId);
  const role = useAuthStore((state) => state.role);
  const isSuperAdmin = useAuthStore((state) => state.isSuperAdmin);
  const tenantId = useAuthStore((state) => state.tenantId);
  const tenantSlug = useAuthStore((state) => state.tenantSlug);

  return {
    isLoading: status === "loading",
    isAuthenticated: status === "authenticated",
    user: status === "authenticated" ? { userId, role, isSuperAdmin, tenantId, tenantSlug } : null,
  };
}
